module.exports = __webpack_public_path__ + "342c1b7b15bc514fc488a9c2d2bc2657.svg";